/**
 * @author https://gitee.com/chu1204505056/vue-admin-better （不想保留author可删除）
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import Vue from 'vue' 
import { resetRouter } from '@/router' 
import { config } from '@/api/api'

const state = () => ({
  accessToken: '',
  username: '',
  avatar: '',
  permissions: [],
  userinfo:'', 
  common:''
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  permissions: (state) => state.permissions,
  userinfo: (state) => state.userinfo, 
  common: (state) => state.common, 
}
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken 
  },
  setUsername(state, username) {
    state.username = username
  },
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
  },
  setUserinfo(state, data) {
    state.userinfo = data
  },  
  common(state, data) {
    state.common = data
  },  
}
const actions = {
  setPermissions({ commit }, permissions) {
    commit('setPermissions', permissions)
  },
  async login({ commit }, userInfo) {  
   
  },
  async getUserInfo({ commit, state }) { 
      commit('setPermissions', permissions)
      commit('setUsername', nickname)
      commit('setAvatar', avatar)
      commit('setUserinfo', data)   
  },
  async config({ commit, state }) {
    const { data } = await config();
    console.log(data,'datadatadatadatadata')
  },
  async logout({ dispatch }) {
    // await logout(state.accessToken)z
    await dispatch('resetAccessToken')
    await resetRouter()
  },
	async getRule({ commit, state }){
		let {data} =await getRule();
	},
  resetAccessToken({ commit }) {
    commit('setPermissions', [])
    commit('setAccessToken', '') 
  },
  setCommon({ commit },data) {
    commit('setPermissions', [])
    commit('setAccessToken', '') 
  },
}
export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/user.js